<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocId"
      ref="list"
      unit="领料通知单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      :expand-all-row="true"
      :show-checkbox="true"
      @row-select="rowSelect"
      @onSelCheck="onSelCheck"
      @onAllCheck="onAllSelCheck"
      v-if="trendShow"
      urlHash="production/ticketmanagement/materials"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"> </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <!-- 明细 -->
    <el-button v-if="show" type="primary" @click="onCustomTable" icon="el-icon-s-tools" style="margin: 30px 0 10px 10px"> 明细项 </el-button>
    <el-table ref="multipleTable" :row-key="row => row.Prop" :data="tableData" v-if="show" stripe border>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog ref="customTableDialog" @onSave="onSave" :initTableData="tableColumns" tableType="领料通知单明细" />
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
import customTableDialog from '@/components/common/customTableDialog/customTableDialog'

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require('@/api/pr/prGetDocTask').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      FieldSettingApi: require('@/api/sy/fieldSetting').default,
      trendShow: true,
      tableData: [],
      params: {
        ProcessingType: null,
        Status: null
      },
      tableColumns: [],
      show: false
    }
  },
  activated() {},
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/productionshipping')
    }
  },
  created() {
    this.getTableColumns()
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false
      const priceProps = ['PurchasePrice', 'SalePrice', 'RetailPrice', 'QuotedPrice', 'Discount', 'TaxRate', 'Price', 'TaxPrice', 'Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'Rate', 'Price']
      return (this.canPrice && priceProps.includes(item.Prop)) || !priceProps.includes(item.Prop)
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ['PuQuantity', 'Amount', 'TaxAmount'].includes(prop)
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: '领料通知单明细' })
      this.tableColumns = []
      this.tableColumns = res.Data
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true
    },
    rowSelect(row) {
      // this.show = true
      // let id = row.DocId;
      // this.api.info(id).then(res => {
      //     if(res.Code === 0){
      //       this.tableData = res.Data.Products;
      //     }
      // })
    },
    onSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        return
      }

      this.show = true
      this.tableData = []
      const Ids = selection.map(item => item.DocId)
      const o = {
        Ids: Ids
      }
      this.api.infos(o).then(res => {
        this.tableData = res.Data
      })
    },
    onAllSelCheck(selection) {
      if (selection.length == 0) {
        this.tableData = []
        return
      }
      this.show = true
      const Ids = selection.map(item => item.DocId)
      const o = {
        Ids: Ids
      }
      this.api.infos(o).then(res => {
        this.tableData = res.Data
      })
    },
    onSave() {
      this.getTableColumns()
      this.$message.success('保存成功')
    }
  }
}
</script>
